import React, { FC } from 'react';
import { useLocation } from 'react-router-dom';

import { AnswerTypes } from 'types';

import Button from 'components/Button';
import Header from 'components/Header';

import useSentSessionStarted from 'hooks/useSentSessionStarted';
import sendAnalyticsEvent from 'utils/sendAnalyticsEvent';

const FirstScreen: FC<AnswerTypes> = (props) => {
    const {
        image,
        text,
        title,
        buttonText,
        logoUrl,
        termsLink,
        policyLink,
        subscriptionLink,
        handleSwitchToNextScreen,
        logoLink,
        id,
    } = props;

    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const quizScreenFromUrl = Number(params.get('screen'));

    useSentSessionStarted();

    const handleOnClick = () => {
        handleSwitchToNextScreen();
        sendAnalyticsEvent({
            eventName: 'page_completed',
            data: {
                page_number: quizScreenFromUrl,
                question: id,
            },
        });
    };

    return (
        <section className="first_screen">
            <Header logoUrl={logoUrl} isHiddenProgress logoLink={logoLink} />
            <div className="first_screen__inner-wrapper">
                <div className="first_screen__wrapper">
                    {image && (
                        <figure className="first_screen__figure">
                            <img src={image} alt="" />
                        </figure>
                    )}
                    <div className="first_screen__wrap">
                        {title && <h2 className="first_screen__title" dangerouslySetInnerHTML={{ __html: title }} />}
                        {text && <p className="first_screen__text" dangerouslySetInnerHTML={{ __html: text }} />}
                        <Button onClick={handleOnClick} text={buttonText} />
                    </div>
                </div>
                <nav className="first_screen__nav">
                    <a href={termsLink} target="_blank" rel="noreferrer">
                        Terms & Conditions
                    </a>
                    <span className="first_screen__seporator">•</span>
                    <a href={policyLink} target="_blank" rel="noreferrer">
                        Privacy Policy
                    </a>
                    <span className="first_screen__seporator">•</span>
                    <a href={subscriptionLink} target="_blank" rel="noreferrer">
                        Subscription Policy
                    </a>
                </nav>
            </div>
        </section>
    );
};

export default FirstScreen;
